// extracted by css-extract-rspack-plugin
export default {"breadcrumbTree":"breadcrumbTree-nKql8b","controls":"controls-er04UN"};